import { Lightning, Log, Utils } from "@lightningjs/sdk";
import { List, Grid } from "@lightningjs/ui";
import TextItem from "../ui-elements/item-text";
import KeyboardAdvanced from "../ui-elements/keyboard-advanced";
import {
  fetchData,
  getSearchSuggestion,
} from "../lib/models/data-service";
import RowColumnGrid from "../lib/components/grid/row-column-grid";
import { GRIDTYPE, REQUEST_STATUS } from "../lib/enum";
import { AppData } from "@lightningjs/sdk";
import { AppSetup } from "../lib/app-setup";
import Router from "@lightningjs/sdk/src/Router";
import { Logger } from "../lib/logger";
import { KeyCodes } from "../lib/key-codes";
import { Helper } from "../lib/helper";

export interface SearchScreenTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Background: object;
  Title: object;
  SuggestionList: List;
  SearchListThumbItem: Grid;
  KeyboardPanel: object;
}

export interface SearchScreenTypeConfig extends Lightning.Component.TypeConfig {
  IsPage: true;
}

export default class SearchScreen
  extends Lightning.Component<SearchScreenTemplateSpec, SearchScreenTypeConfig>
  implements Lightning.Component<SearchScreenTemplateSpec>
{
  prevPage:string = 'grid';
  isMenuFocused = false
  Title = this.getByRef("Title")!;
  SuggestionList = this.getByRef("SuggestionList")!;
  SearchListThumbItem = this.getByRef("SearchListThumbItem")!;
  KeyboardPanel = this.getByRef("KeyboardPanel")!;
  suggestionItemTotal = 0;
  suggestionItemFetchPageStatus: REQUEST_STATUS[] = []
  searchStr = ''
  args:any;
  previousState = ''
  suggestionListItems:any=[];
  static override _template(): Lightning.Component.Template<SearchScreenTemplateSpec> {
    /*const { appState } = AppData as AppSetup;
    const searchScreenObject: SearchScreenInfo | undefined =
      appState?.getAppApiConfig()?.appConfig?.searchscreen;
    Log.info("SearchScreen:", searchScreenObject);*/
    return {
      ...super._template(),
      w: 1920,
      h: 1080,
      // rect: true,
      // color: 0xff222343,
      Background: {
        rtt: false,
        w: 1920,
        h: 1080,
        // color: 0xff222343,
        collision:true,
      },
      BackButton: {
          collision: true,
          x: 180,
          y: 60,
          alpha: 0.7,
          texture: {
              src: Utils.asset('images/ico-back.png'),
              resizeMode: {
                  h: 40,
                  w: 40,
                  type: 'contain',
              },
              type: Lightning.textures.ImageTexture
          }
      },
      SearchTitle: {
        x: 180+60,
        y: 50,
        text: { text: 'SEARCH', fontSize: 42, fontFace: 'Regular' }
      },
      NameTitle: {
        x: 740+60,
        y: 50,
        text: { text: 'Top Searches', fontSize: 42, fontFace: 'Regular', wordWrap: false, wordWrapWidth: 800, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis' }
      },
      Title: {
        x: 1620,
        y: 50,
        text: { text: '', fontSize: 42 , fontFace: 'Regular', wordWrapWidth: 800, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis' },
        visible: true,
      },
      KeyboardPanel: {
        x: 80+60,
        y: 100,
        type: KeyboardAdvanced,
        collision:true,
        signals: { onInputChanged: true },
      },
      SuggestionList: {
        rect: true,
        clipping: true,
        collision:true,
        color: 0x00ffff00,
        type: List,
        direction: "column",
        x: 180+60,
        y: 840,
        w: 490,
        h: 220,
        signals: { onIndexChanged: true },
      },
      SearchListThumbItemWrapper:{
        rect: true,
        clipping: true,
        collision:true,
        color: 0x00ffff00,
        x: 700+60,
        y: 130,
        w: 1200,
        h: 880,
        SearchListThumbItem: {
          x: 40,
          y: 20,
          collision:true,
          type: RowColumnGrid
          // rect: true,
          // clipping: true,
          // color: 0x00ffff00,
          // w: 1200,
          // h: 880,
        },
      }
    };
  }

  override _handleKey(e: KeyboardEvent): boolean | void {
    if(e.keyCode == KeyCodes.KEY_EXIT) {
      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      app?.handleAppExit()
      return true
    }
  }

  onIndexChanged(indexData:any) {
    const nextFocusItemIndx = indexData.index
    const nextPageToFetch = Math.ceil(nextFocusItemIndx / 20)
    const totalPageCount = Math.ceil(this.suggestionItemTotal / 20)
    const items: any = []
    if (nextPageToFetch <= totalPageCount - 1 &&
      nextFocusItemIndx % 10 == 0 &&
      this.suggestionItemFetchPageStatus[nextPageToFetch] == undefined) {
      const url = getSearchSuggestion(this.searchStr, nextPageToFetch);
      this.suggestionItemFetchPageStatus[nextPageToFetch] = REQUEST_STATUS.FETCHING
      fetchData(url).then((response) => {
        const searchResults = response.data;
        let results = searchResults.results;
        this.suggestionItemFetchPageStatus[nextPageToFetch] = REQUEST_STATUS.OK
        for (let i = 0; i < results.length; i++) {
          items.push({
            type: TextItem,
            w: 490,
            h: 70,
            margin: 2,
            item: { label: results[i].title },
          });
        }
        this.tag("SuggestionList").addAt(items, nextPageToFetch * 20)
        this.suggestionListItems = this.suggestionListItems.concat(items);
      });
    }
  }

  onInputChanged(event: any) {
    const { appConfig, platform } = AppData as AppSetup;
    Log.info('HISTORY : onInputChanged called useHistory = ',appConfig?.useHistory, event)
    this.searchStr = event.input
    // if (event.input.length >= 2) {
    //     if(event.previousInput.indexOf('  ')<0){
          this.loadSearchResults(event.input)
          this.tag("SearchListThumbItem").searchKey = event.input;
          //let searchTitle = `Loading Results for "${this.searchStr}"`
          let searchTitle = `Loading Results`
          this.patch({
            Title: {
              x:1430,
              text: {
                text: searchTitle,
              },
            },
          });
          platform?.textToSpeach('Search suggestions loaded')
    //    }
    //}
  }

  $handleChange(event:any){
    let searchStr = '';
    searchStr = event.str.split('Search: ').join('');
    const appendString = searchStr == '' ? '' : ` Results for "${searchStr}"`
    // let searchTitle = `${event.curr+1} of ${event.count}${appendString}`
    let searchTitle = `${event.curr+1} / ${event.count}`
    if(event.count < 0) return
    //let searchTitle = `${event.curr+1} of ${event.count} Results`
    this.patch({
      Title: {
        x: 1630,
        text: {
          text: searchTitle,
        },
      },
    });
    if(this._getState()=="SuggestionList"){
      this.$setStateHover("SearchListThumbItem");
    }
  }

  loadSearchResults = (term: any) => {
    const url = getSearchSuggestion(term, 0);
    this.suggestionItemFetchPageStatus = []
    this.suggestionItemFetchPageStatus[0] = REQUEST_STATUS.FETCHING
    fetchData(url).then((response) => {
      const searchResults = response.data;
      let items = [];
      let results = searchResults.results;
      this.suggestionItemTotal = searchResults.count
      this.suggestionItemFetchPageStatus[0] = REQUEST_STATUS.OK
      for (let i = 0; i < results.length; i++) {
        items.push({
          type: TextItem,
          w: 490,
          h: 70,
          itemIndex: i,
          margin: 2,
          item: { label: results[i].title },
        });
      }
      this.suggestionListItems = items;
      this.tag("SuggestionList").reload(items)
    });
  };

  loadHistoryData=()=>{
    Log.info("HISTORY : ","loadHistoryData called");
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    const searchHistroyInfo = app?.navigation.getSearchHistroyInfo();
    Log.info("HISTORY : searchHistroyInfo ",searchHistroyInfo);
    const suggestionListItems = searchHistroyInfo.suggestionListItems;
    try{
      this.tag("SuggestionList").reload(suggestionListItems);
    } catch(e){
      Log.info("HISTORY : SuggestionList load error ",e);
    }
    try {
      this.tag("SearchListThumbItem").loadHistoryData(searchHistroyInfo);
    } catch(e){
      Log.info("HISTORY : SearchListThumbItem load error ",e);
    }
    this.suggestionItemTotal = searchHistroyInfo.suggestionItemTotal;
    this.searchStr = searchHistroyInfo.searchStr;
  }

  /* Fix for XFIN-1093  */
  _handleBookmarking(vodInfo) {
    this.widgets.bookmark.$setbdata(vodInfo)
    Router.focusWidget('Bookmark')
  }
  _handleVideoResume(vodInfo) {
    const { appConfig, appState } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig()
    let resumeTime = null
    if (appConfig?.useLocalStorage == true) {
        resumeTime = localStorage.getItem(vodInfo.node_id)!;
    } else {
        resumeTime = Helper.getCookie(vodInfo.node_id);
    }
    if (resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && resumeTime !== '0' && (appApiConfig?.appConfig?.resumeVidMinDuration && vodInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {
        this.widgets.bookmark.$setbdata(vodInfo)
        Router.focusWidget('Bookmark')
    } else {
        Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
    }
  }
/* Fix for XFIN-1093  */

  override _init() {
    const { appConfig, appState } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig()
    if (appApiConfig?.appBrandConfig?.iptv_background) {
      this.patch({
        Background: {
            src: appApiConfig.appBrandConfig.iptv_background,
        },
      })
    }
    if(appConfig?.useHistory){
      appConfig.useHistory=false;
      this.loadHistoryData();
      this.$setStateHover("SearchListThumbItem");
      return;
    } else {
      this.tag("SearchListThumbItem").searchKey = appConfig?.defaultSearchInput;
      this.loadSearchResults(appConfig?.defaultSearchInput)
      this.$setStateHover("KeyboardPanel");
    }

  }

  /* Fix for XFIN-1120 */
  override _firstActive() {
    const { appConfig } = AppData as AppSetup
    if(this.prevPage === 'player' || appConfig?.appEnv == 'auto'){
      this.widgets.menu.visible = false
      this.tag('KeyboardPanel')?.patch({ x: 20 })
      this.tag('SuggestionList')?.patch({ x: 120 })
      this.tag('SearchTitle')?.patch({ x: 120 })
      this.tag('BackButton')?.patch({ x: 60 })
    }
  }
  /* Fix for XFIN-1120 */

  override _getFocused():
    | Lightning.Component<
      Lightning.Component.TemplateSpecLoose,
      Lightning.Component.TypeConfig
    >
    | null
    | undefined {

      const { appConfig } = AppData as AppSetup;
      if(appConfig?.useHistory){
        return this.tag("SearchListThumbItem");
      } else {
        return this.tag("KeyboardPanel");
      }

  }

  // override _focus() {
  //   const { appConfig } = AppData as AppSetup;
  //   if(appConfig?.useHistory){
  //     this.$setStateHover("SearchListThumbItem");
  //   } else {
  //     this.$setStateHover("KeyboardPanel");
  //   }
  // }

  override _handleRight() {
    Log.info("_handleRight");
    this.$setStateHover("SearchListThumbItem");
  }
  override _handleLeft() {
    Log.info("_handleLeft");
    this.$setStateHover("KeyboardPanel");
  }
  override _handleUp() {
    Log.info("_handleUp");
  }
  override _handleDown() {
    Log.info("_handleDown");
  }
  override _handleEnter() {
    Log.info("_handleEnter1 ");
  }

  override set params(args:any){
    this.args = args;
    /*if(this.args.prevPage === 'player'){
      const { appConfig } = AppData as AppSetup;
      appConfig.searchInput = appConfig.defaultSearchInput
    }*/
  }

  closeSearch(){
    const { appState , platform, appConfig } = AppData as AppSetup
    let prevPage = ''
        if(this.args.prevPage === 'player'){
          prevPage='player';
        }
        platform?.textToSpeach('Closing search box')
        const app = appState?.getApp()
        app?.handleBackNavigation(prevPage)
        Logger.processUserAction('closingSearch');
  }

  $onCancel(event){
    this.closeSearch()
  }

  override _handleBack(e) {
    //console.log('searchscreen back event', e);

    const { appState , platform, appConfig } = AppData as AppSetup
    if(appConfig?.enableContextualBackspace && this.searchStr.length > 0) {
      this.tag('KeyboardPanel').onCustom(event)
    } else if(!e.repeat) {
      this.closeSearch()
    }

  }

  $SuggestionListhandleEnter() {
    Log.info("SuggestionList ", this.tag("SuggestionList").index, this.tag("SuggestionList").currentItem._item.label);
    const searchStr = this.tag("SuggestionList").currentItem._item.label
    this.tag('SearchListThumbItem').searchKey=searchStr
    // this.tag("NameTitle").patch({
    //   text: { text: searchStr }
    // });
    // const inputField = this.tag("KeyboardPanel").tag("InputFieldWrapper").tag("InputField");
    // inputField.patch({ inputText: { text: searchStr } });
  }

  /*-----XFIN-1302-----*/
  $updateThumbNameTitle(title: string) {
    this.tag('NameTitle').patch({
      text: { text: title }
    })
  }

  static _states() {
    return [
      class KeyboardPanel extends this {
        override _getFocused() {
          return this.tag("KeyboardPanel");
        }
        override _handleLeft() {
          Log.info('Search Screen:', '_handleLeft fired')
          if(this.prevPage === 'player') return true   // XFIN-1120  To disable left action while there is no menu widget
          Router.focusWidget('Menu')
          this.isMenuFocused = true;
          return true
      }
        override _handleRight() {
          this.$setStateHover("SearchListThumbItem");
        }
        override _handleDown() {
          this.$setStateHover("SuggestionList");
        }
      },

      class SuggestionList extends this {
        override _getFocused() {
          return this.tag("SuggestionList");
        }
        override _handleUp() {
          this.$setStateHover("KeyboardPanel");
        }
        override _handleRight() {
          this.$setStateHover("SearchListThumbItem");
        }
        override _handleEnter() {
          this.$SuggestionListhandleEnter()
        }
      },

      class SearchListThumbItem extends this {
        override _getFocused() {
          return this.tag("SearchListThumbItem");
        }
        override _handleLeft() {
          this.$setStateHover("KeyboardPanel");
        }
        $handleEnter() {
          if(this.tag("SearchListThumbItem").requestInProgress){
            return;
          }
          const { appState } = AppData as AppSetup
          const app = appState?.getApp()
          const sGrid = this.tag("SearchListThumbItem").gridViewModel;
          const vodInfo = sGrid.getFocusedItem()
          if(app?.blockingManager.isItemBlocked(vodInfo))  {
            this.widgets.notification.showMessage('')
            return;
          }
          /* This is restricting to single navigation stack instead of multiple navigation stack when user open in player search multiple times */
          if(app?.navigation.getCurrentGrid().type === GRIDTYPE.SEARCH){
            app?.navigation.pop()
          }
          /*  */
          app?.navigation.push(this.tag("SearchListThumbItem").gridViewModel)

          let rowListItems = this.tag("SearchListThumbItem").rowListItems;
          let suggestionListItems = this.suggestionListItems;
          let savedSearchHistroyInfo = app?.navigation.getSearchHistroyInfo();
          if(!rowListItems || rowListItems.length<=0){
            rowListItems = savedSearchHistroyInfo.rowListItems
          }
          if(!suggestionListItems || suggestionListItems.length<=0){
            suggestionListItems = savedSearchHistroyInfo.suggestionListItems
          }

          let searchHistroyInfo = {
            //suggestionListItems:this.tag("SuggestionList").items
            suggestionListItems:suggestionListItems,
            suggestionItemTotal:this.suggestionItemTotal,
            rowListItems:rowListItems,
            gridViewModel:this.tag("SearchListThumbItem").gridViewModel,
            searchStr:this.searchStr
          }
          Log.info("HISTORY : Search Histroy Info ",searchHistroyInfo);
          app?.navigation.setSearchHistroyInfo(searchHistroyInfo);


          Log.info("SearchListThumbItem ",vodInfo);
          const { appConfig } = AppData as AppSetup;
          appConfig.searchInput = this.searchStr;
          //XFIN-692 - added this condition for commonly hitting the close tracker when user selects any video/mlp from search.
          if(this.args.prevPage === 'player'){
            app?.videoObj.hitCloseTracker()
          }
          if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
            Logger.processUserAction('mlpSelectedFromSearchSuggestions');
            // Router.navigate(`mlp-grid-screen/${vodInfo.id}`, false)
            this._handleBookmarking(vodInfo)
          } else if (vodInfo.feed_type == 'video') {
            Logger.processUserAction('videoSelectedFromSearchSuggestions');
            // Router.navigate('video-screen/'+vodInfo.node_id, false)
            this._handleVideoResume(vodInfo)
          }
        }
      },
    ];
  }

  $setStateHover(newState) {
    //KeyboardPanel //SearchListThumbItem //SuggestionList
    if(this.previousState !== newState) {
      this._setState(newState);
      this.previousState = newState
    }
  }

  override _handleUp(e) {
    //console.log('_handleUp', this._getState())
  }

  _handleScroll(obj) {
    const curState = this._getState()
    let tag = null
    if(curState == 'SuggestionList') {
      tag = this.tag('SuggestionList')
    }
    if(tag !== null) { 
      if (obj && obj.wheelDeltaY && obj.wheelDeltaY > 0) {
        tag.previous()
      } else {
        tag.next()
      }
    }
  }

  _handleClick(target) {
    if (target.ref == 'BackButton') {
        this._handleBack({repeat:false})
    }

  }

  _handleTouchStart(details, component) {
    Log.info('MainGrid: _handleTouchStart : ', details, component)
    if((component.itemType && component.itemType.name)  == 'ThumbItem') {
        this.$setStateHover("SearchListThumbItem");
    } else if(component.__ref == 'Key') {
        this.$setStateHover("KeyboardPanel");
    } else if(component.__ref == 'TextItem') {
      this.$setStateHover("SuggestionList");
    }
  }

  
}
let searchResults = {};
